import { createContext } from 'react'
import { CollectionProduct } from 'types/collection'

export type MultisizeModels = {
  [handle: string]: CollectionProduct['images']
}

export type CollectionContextType = {
  collectionHandle: string
  hasMultipleProductTypes: boolean
  collectionMainTitle: string
  isApplyFitActive: boolean
  setIsApplyFitActive: (state: boolean) => void
  isFiltersOpen: boolean
  closeFilters: () => void
  openFilters: () => void
}

const CollectionContext = createContext<CollectionContextType>({
  collectionHandle: '',
  isApplyFitActive: false,
  setIsApplyFitActive: () => undefined,
  hasMultipleProductTypes: false,
  collectionMainTitle: '',
  isFiltersOpen: false,
  closeFilters: () => undefined,
  openFilters: () => undefined
})

export default CollectionContext
